module.exports = __webpack_public_path__ + "img/under-maintenance-dark.6679b467.svg";